export const chartTypes = {
  Map: "map",
  Trend: "trend",
  Bar: "bar",
  Correlation: "correlation",
  DataTable: "datatable",
  StackedBar: "stackedBar",
  Pie: "pie",
}

export const mapTypes = {
  Country: "country",
  Region: "region",
  Continent: "continent",
  IncomeGroup: "incomeGroup",
}

export const metadataToInternalChartType = {
  stacked_bar: chartTypes.StackedBar,
  line: chartTypes.Trend,
  scatter: chartTypes.Correlation,
}
export const disaggregations = {
  RefArea: 'REF_AREA',
  Frequency: 'FREQ',
  UnitMeasure: 'UNIT_MEASURE',
  UnitMult: 'UNIT_MULT',
  TimePeriod: 'TIME_PERIOD',
  Decimals: 'DECIMALS',
  UnitType: 'UNIT_TYPE',
  Region: 'REGION',
}

export const endpointLabels = {
  PortalMetadata: "portalMetadata",
  GetEntitiesById: "getEntitiesById",
  YouMightAlsoLike: "youMightAlsoLike",
  AdminMetadata: "adminMetadata",
  CodelistRefGroupings: 'codelistRefGroupings',
  Data: "data",
  Grouping: "grouping",
  Hierarchy: "hierarchy",
  MapBoundaries: "mapboundaries",
  RegionBoundaries: "regionboundaries",
  ContinentBoundaries: "continentboundaries",
  MapCentroids: "mapcentroids",
  Dimensions: "dimensions",
}

export const aggregates = {
  Region: { id: "regional", name: "Corresponding region aggregates" },
  IncomeGroup: {
    id: "incomeGroup",
    name: "Corresponding income group aggregates",
  },
}

export const periodicity = {
  Annual: "A",
  Triennial: "A3",
  Quarterly: "Q",
  Monthly: "M",
  Hourly: "H",
  Daily: "D",
  HalfYearlySemester: "S",
}

export const QueryParams = {
  IndicatorID: "indicatorID",
  View: 'view',
  CountrySelection: 'country',
  MinYear: 'minYear',
  MaxYear: 'maxYear',
  Year: 'year',
  SecondIndicator: 'secondIndicator',
  ComparisonBy: 'comparisonBy',
  RecentYearSelection: 'recentYear',
  Average: 'average',
  OnlyShow: 'onlyShow',
  UnitMeasure: 'unitMeasure',
  Frequency: 'frequency',
  MapType: 'mapType',
  SecondUnitMeasure: 'secUnitMeasure',
}

// For color mapping -- start
export const Gender = {
  Female: 'F',
  Male: 'M',
  NonResponse: '_N',
  Other: '_O',
  Unknown: '_U',
  NotApplicable: '_Z',
}

export const Total = "_T"

export const Urbanization = {
  Rural: "RUR",
  Urban: "URB",
}

export const Region = {
  LatinAmerica: "LCN",
  SouthAsia: "SAS",
  Africa: "SSF",
  Europe: "ECS",
  MiddleEast: "MEA",
  EastAsia: "EAS",
  NorthAmerica: "NAC",
  World: "WLD",
  WestAfrica: "AFW",
  EastAfrica: "AFE",
}

export const IncomeGroup = {
  High: "HIC",
  Low: "LIC",
  LowerMid: "LMC",
  UpperMid: "UMC",
  UnClassified: 'INX',
}

export const ScaleTypes = {
  Sequential: "sequential",
  SequentialReverse: "sequential reverse",
  Sequential_Reverse: "sequential_rev",
  Diverging: "diverging",
  DivergingReverse: "diverging reverse",
  Diverging_Reverse: "diverging_rev",
  Categorical: "cat",
}

export const LegendType = {
  Continuous: "continuous",
  Binned: "binned",
}

export const ChartElements = {
  ZeroLine: "zero line",
  GridLine: "grid line",
  MinorGridLineLogAxis: "minor_gridline_log_axis",
}
// For color mapping -- end

// Advanced visualization -- start
export const BinTypes = {
  Custom: "custom",
  Percentile: "percentile",
  Equal: "equal",
  StandardDeviation: "stdev",
}
export const AxisValues = {
  Linear: "linear",
  Exponential: "exp",
  Logarithmic: "nat_log",
}
// Advanced visualization -- end
export const MissingDataLineTypes = {
  ShowBreaks: "show_breaks",
  Continuous: "continuous",
}

export const MissingDataBarTypes = {
  ShowNA: 'show_na',
  RemoveGaps: 'remove_gaps',
}

export const MissingDataMapTypes = {
  DefaultColor: "use_default_color",
  SpecifyColor: "specify_color",
}

export const Breakpoint = {
  TabletWide: 1024,
  Tablet: 800,
  Mobile: 600,
}

export const featureType = {
  IndicatorProfile: 'indicatorProfile',
}
